import React from "react";
import { FaBarcode, FaCreditCard, FaPix } from "react-icons/fa6";

export enum PaymentOptionsEnum {
    BANK_SLIP = 'bank_slip',
    CREDIT_CARD = 'credit_card',
    PIX = 'pix'
}

export enum PaymentOptionsStatusEnum {
    BANK_SLIP = 'activated',
    CREDIT_CARD = 'disabled',
    PIX = 'disabled'
}

export function PaymentOptionsIconEnum(method: string) {
    switch (method) {
        case PaymentOptionsEnum.BANK_SLIP:
            return <FaBarcode />
        case PaymentOptionsEnum.CREDIT_CARD:
            return <FaCreditCard />
        case PaymentOptionsEnum.PIX:
            return <FaPix />
    }
}